export const ROUTER_DATA = {
  CREATE_CONTACT :'/hrm/contact/create'
}
